import { type ReactNode, useState } from 'react'

export function Accordion({
	children,
	type,
	collapsible,
	className,
}: {
	children: ReactNode
	type: 'single'
	collapsible: boolean
	className: string
}) {
	return <div className={className}>{children}</div>
}

export function AccordionItem({
	children,
	value,
}: {
	children: ReactNode
	value: string
}) {
	const [isOpen, setIsOpen] = useState(false)
	return (
		<div className="border-b border-gray-200 last:border-0">
			<div onClick={() => setIsOpen(!isOpen)}>{children}</div>
		</div>
	)
}

export function AccordionTrigger({
	children,
	className,
}: {
	children: ReactNode
	className: string
}) {
	return (
		<div className={`${className} cursor-pointer px-4 py-4 hover:bg-gray-50`}>
			{children}
		</div>
	)
}

export function AccordionContent({ children }: { children: ReactNode }) {
	return <div className="px-4 pb-4">{children}</div>
}
